<template>
  <div class="section-content">
    <!-- <EventsCenter :serveUrl="flowServeUrl" :request="request" :tabNum="tabNum"/> -->
    <EventsCenterNew
      :serveUrl="flowServeUrl"
      :baseUrl='baseUrl'
      :request="request"
      :scrollClass="node"
      :tabNum="tabNum"
      :eventListSetting="config.EVENT_LIST_SETTING"
      :todoEventEntry="config.TO_DO_PROXY_ENTRY !== '0'"
      :baseUserUrl='baseUserUrl'
      :historyCheckUrl="historyCheckUrl"
    />
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import configR from '@/configs.js';

/*            ****************************************          */
// import EventsCenterNew from './main.vue'
/*            ****************************************          */
export default {
  name: "Events",
  computed: {
    ...mapGetters(["token", "userInfo", "flowServeUrl", "request"]),
  },
  /*            ****************************************          */
  components: {
    // EventsCenterNew
  },
  /*            ****************************************          */
  data() {
    return {
      tabNum: this.$route.params.tabNum ? this.$route.params.tabNum : 0,
      node: "app-main-wrapper",
      config: configR.envConfigs,
      baseUserUrl: configR.envConfigs.ADMIN_CENTER_API,
      baseUrl: configR.envConfigs.FORMFLOW_API_URL,
      historyCheckUrl:configR.envConfigs.HISTORY_CHECK_URL
    };
  },
  watch: {},
  methods: {},
};
</script>
<style lang="scss">
@import "@/styles/variables.scss";
.section-content {
  width: 1680px;
  margin: 0 auto;
  @include portalMedia;
  .business {
    flex: 1;
  }
}
</style>